import { drawArrow } from "./arrows";
import { pixels } from "../../../constants/pixels";
// import { windowColors } from "./constants";

export const window2 = (p5, trait, width, yurtTrait) => {
  const frenchDoorH = 81.5 * pixels;

  const xcenter = width / 2;
  const ycenter = yurtTrait.h / 2 + 5 * pixels;
  const bottomBoard = {
    x: xcenter,
    y: ycenter + (yurtTrait.h / 2 + trait.twoByW / 2),
  };

  // Don't let it get any bigger than the width of the wall
  if (trait.window2.windowW > 42 * pixels) {
    trait.window2.windowW = 42 * pixels;
  }

  // jacks

  p5.push();
  p5.rectMode(p5.CENTER);
  p5.translate(bottomBoard.x, bottomBoard.y - trait.twoByW / 2);
  p5.fill("lightgrey");

  const centerWindowX = trait.window2.windowW / 2 + trait.twoByW / 2;
  const centerSillHeight = -trait.window2.sill / 2 - trait.window2.windowH / 2;
  const totalSillWindowHeight = trait.window2.sill + trait.window2.windowH;
  let casementWidth = 0;

  if (trait.window2.placement / pixels === 1) {
    casementWidth = -(trait.w - trait.window2.windowW) / 2 + trait.twoByW * 2;
  } else if (trait.window2.placement / pixels === 2) {
    casementWidth = (trait.w - trait.window2.windowW) / 2 - trait.twoByW * 2;
  }

  let sillHeight = trait.window2.sill;

  if (!trait.frenchDoor && !trait.doors) {
    if (yurtTrait.stud / trait.pixels >= 24) {
      p5.rect(
        0 + casementWidth,
        -trait.window2.sill / 2,
        trait.twoByW,
        sillHeight
      );
    } else {
      p5.rect(
        8 * trait.pixels,
        -trait.window2.sill / 2,
        trait.twoByW,
        sillHeight
      );
      p5.rect(
        -8 * trait.pixels,
        -trait.window2.sill / 2,
        trait.twoByW,
        sillHeight
      );
    }
  }

  if (trait.frenchDoor === "right") {
    p5.rect(
      centerWindowX + casementWidth - trait.window2.windowW - trait.twoByW,
      centerSillHeight,
      trait.twoByW,
      totalSillWindowHeight
    );

    p5.rect(
      centerWindowX + casementWidth,
      centerSillHeight,
      trait.twoByW,
      totalSillWindowHeight
    );
  } else if (trait.frenchDoor === "left") {
    p5.rect(
      -centerWindowX + casementWidth,
      centerSillHeight,
      trait.twoByW,
      totalSillWindowHeight
    );
    p5.rect(
      centerWindowX + casementWidth,
      centerSillHeight,
      trait.twoByW,
      totalSillWindowHeight
    );
  } else if (trait.frenchDoor === "center") {
    const header = trait.frenchHeader;
    p5.rect(
      -centerWindowX + casementWidth,
      centerSillHeight - frenchDoorH / 2 - header / 2 - trait.twoByW / 4,
      trait.twoByW,
      totalSillWindowHeight - frenchDoorH - header - trait.twoByW / 2
    );
    p5.rect(
      centerWindowX + casementWidth,
      centerSillHeight - frenchDoorH / 2 - header / 2 - trait.twoByW / 4,
      trait.twoByW,
      totalSillWindowHeight - frenchDoorH - header - trait.twoByW / 2
    );
  } else if (trait.doors) {
    p5.rect(
      centerWindowX + casementWidth,
      centerSillHeight - (trait.doorH + trait.header + trait.twoByW) / 2,
      trait.twoByW,
      totalSillWindowHeight - trait.doorH - trait.header - trait.twoByW
    );
    p5.rect(
      -centerWindowX + casementWidth,
      centerSillHeight - (trait.doorH + trait.header + trait.twoByW) / 2,
      trait.twoByW,
      totalSillWindowHeight - trait.doorH - trait.header - trait.twoByW
    );
  } else if (trait.windows > 1) {
    p5.rect(
      centerWindowX + casementWidth,
      centerSillHeight,
      trait.twoByW,
      totalSillWindowHeight
    );
    p5.rect(
      -centerWindowX + casementWidth,
      centerSillHeight,
      trait.twoByW,
      totalSillWindowHeight
    );
  } else {
    p5.rect(
      centerWindowX + casementWidth,
      centerSillHeight,
      trait.twoByW,
      totalSillWindowHeight
    );
    p5.rect(
      -centerWindowX + casementWidth,
      centerSillHeight,
      trait.twoByW,
      totalSillWindowHeight
    );
  }

  let frenchDoorPlate = 10.5 * pixels;
  if (trait.frenchW === "6ft") {
    frenchDoorPlate = 16.5 * pixels;
  }

  // sill

  p5.translate(casementWidth, -trait.window2.sill + trait.twoByW);

  if (trait.window2.windowW / pixels === 42) {
    p5.rect(0, 0, trait.window2.windowW + trait.twoByW * 2, trait.twoByW);
  } else {
    p5.rect(0, 0, trait.window2.windowW, trait.twoByW);
  }

  // window
  p5.translate(0, -trait.twoByW / 2 - trait.window2.windowH / 2);

  p5.fill("#dcc2f2");

  p5.rect(0, 0, trait.window2.windowW, trait.window2.windowH);
  p5.fill("lightgrey");

  // lintel
  p5.translate(-casementWidth, -trait.twoByW / 2 - trait.window2.windowH / 2);
  if (
    trait.frenchDoor === "left" &&
    trait.window2.windowH + trait.window2.sill <
      frenchDoorH + trait.frenchHeader
  ) {
    p5.rect(
      -frenchDoorPlate / 2,
      0,
      trait.w - frenchDoorPlate - trait.twoByW * 2,
      trait.twoByW
    );
  } else if (
    trait.frenchDoor === "right" &&
    trait.window2.windowH + trait.window2.sill + trait.window2.header <
      frenchDoorH + trait.frenchHeader + trait.twoByW * 2
  ) {
    p5.rect(
      frenchDoorPlate / 2,
      0,
      trait.w - frenchDoorPlate - trait.twoByW * 2,
      trait.twoByW
    );
  } else {
    p5.rect(0, 0, trait.w - trait.twoByW * 2, trait.twoByW);
  }
  p5.textAlign(p5.CENTER);
  p5.fill("red");
  p5.textSize(20);

  if (trait.window2.tempered === "TEMPERED") {
    p5.text(trait.window2.tempered, casementWidth, trait.window2.windowH / 3);
  }
  p5.fill(0);
  p5.text(trait.window2.windowType, casementWidth, trait.window2.windowH / 2);
  p5.fill("lightgrey");

  // cripple
  p5.translate(0, -trait.twoByW / 2);

  // header
  p5.translate(0, -trait.window2.header / 2);
  if (trait.window2.headerAmount / trait.pixels !== 3) {
    if (
      trait.frenchDoor === "left" &&
      trait.window2.windowH + trait.window2.sill <
        frenchDoorH + trait.frenchHeader + trait.twoByW * 2
    ) {
      p5.rect(
        0 - frenchDoorPlate / 2,
        0,
        trait.w - frenchDoorPlate - trait.twoByW * 2,
        trait.window2.header
      );
    } else if (
      trait.frenchDoor === "right" &&
      trait.window2.windowH + trait.window2.sill + trait.window2.header <
        frenchDoorH + trait.frenchHeader + trait.twoByW * 2
    ) {
      p5.rect(
        0 + frenchDoorPlate / 2,
        0,
        trait.w - frenchDoorPlate - trait.twoByW * 2,
        trait.window2.header
      );
    } else {
      p5.rect(0, 0, trait.w - trait.twoByW * 2, trait.window2.header);
    }
    p5.textAlign(p5.CENTER, p5.CENTER);
    p5.fill(0);
    p5.textSize(80 / pixels);

    p5.text(
      `2 x ${Math.ceil(trait.window2.header / pixels)}`,
      casementWidth,
      40 / pixels
    );
    const headerTypes = ["SINGLE", "DOUBLE", "TRIPLE"];
    p5.text(
      `${headerTypes[trait.window2.headerAmount / pixels]} HEADER`,
      casementWidth,
      -40 / pixels
    );
  }

  p5.pop();

  if (trait.windows <= 1) {
    // sill height arrows
    let outerBottom = p5.createVector(
      bottomBoard.x + 5 * pixels + casementWidth,
      bottomBoard.y + trait.twoByW / 2
    );
    let outerSill = p5.createVector(0, -trait.window2.sill - trait.twoByW / 2);

    if (trait.frenchDoor === "center") {
      outerBottom = p5.createVector(
        bottomBoard.x + 5 * pixels + casementWidth,
        bottomBoard.y - frenchDoorH - trait.frenchHeader
      );
      outerSill = p5.createVector(
        0,
        -trait.window2.sill - trait.twoByW + frenchDoorH + trait.frenchHeader
      );
      drawArrow(
        p5,
        outerBottom,
        outerSill,
        trait.window2.sill + trait.twoByW - frenchDoorH - trait.frenchHeader,
        pixels
      );
    } else if (trait.doors) {
    } else {
      drawArrow(p5, outerBottom, outerSill, trait.window2.sill, pixels);
    }

    // sill inner height arrows
    let innerBottom = p5.createVector(
      bottomBoard.x - 5 * pixels + casementWidth,
      bottomBoard.y - trait.twoByW / 3
    );
    let innerSill = p5.createVector(0, -trait.window2.sill + trait.twoByW);
    if (trait.frenchDoor === "center") {
      innerBottom = p5.createVector(
        bottomBoard.x - 5 * pixels + casementWidth,
        bottomBoard.y - trait.twoByW - frenchDoorH - trait.frenchHeader
      );
      innerSill = p5.createVector(
        0,
        -trait.window2.sill + trait.twoByW + frenchDoorH + trait.frenchHeader
      );
      drawArrow(
        p5,
        innerBottom,
        innerSill,
        trait.window2.sill - trait.twoByW - frenchDoorH - trait.frenchHeader,
        pixels
      );
    } else if (trait.doors) {
      innerBottom = p5.createVector(
        bottomBoard.x - 5 * pixels + casementWidth,
        bottomBoard.y - trait.doorH - trait.twoByW * 1.5
      );
      innerSill = p5.createVector(
        0,
        -trait.window2.sill + trait.twoByW * 1.5 + trait.doorH
      );
      drawArrow(
        p5,
        innerBottom,
        innerSill,
        trait.window2.sill - trait.twoByW * 3 - trait.doorH,
        pixels
      );
    } else {
      if (trait.window2.sill - trait.twoByW * 2 > 0) {
        drawArrow(
          p5,
          innerBottom,
          innerSill,
          trait.window2.sill - trait.twoByW * 2,
          pixels
        );
      }
    }
  } else {
    let outerBottom = p5.createVector(
      bottomBoard.x + 5 * pixels + casementWidth,
      bottomBoard.y - trait.window2.sill
    );
    let outerSill = p5.createVector(0, trait.window2.sill + trait.twoByW / 2);
    let innerBottom = p5.createVector(
      bottomBoard.x - 5 * pixels + casementWidth,
      bottomBoard.y - trait.window2.sill + trait.twoByW
    );
    let innerSill = p5.createVector(0, trait.window2.sill - trait.twoByW);
    // jack arrows
    drawArrow(p5, outerBottom, outerSill, trait.window2.sill, pixels);
    drawArrow(
      p5,
      innerBottom,
      innerSill,
      trait.window2.sill - trait.twoByW * 2,
      pixels
    );
  }

  // cripple arrow

  const lintel =
    bottomBoard.y - trait.window2.windowH - trait.window2.sill - trait.twoByW;

  let windowArrowH0 = p5.createVector(
    xcenter + casementWidth - trait.window2.windowW / 4,
    lintel + trait.window2.windowH + trait.twoByW
  );
  let windowArrowH1 = p5.createVector(0, -trait.window2.windowH);

  drawArrow(p5, windowArrowH0, windowArrowH1, trait.window2.windowH, pixels);

  let windowArrowW0 = p5.createVector(
    xcenter + casementWidth - trait.window2.windowW / 2,
    lintel + trait.window2.windowH + trait.twoByW - 10 * pixels
  );
  let windowArrowW1 = p5.createVector(trait.window2.windowW, 0);

  drawArrow(p5, windowArrowW0, windowArrowW1, trait.window2.windowW, pixels);

  // trimmer arrow on window sides

  let trimmerArrow1 = p5.createVector(
    xcenter + trait.window2.windowW / 2,
    lintel + trait.window2.windowH + trait.window2.sill + trait.twoByW
  );
  let trimmerArrow2 = p5.createVector(
    0,
    -trait.window2.windowH - trait.window2.sill
  );

  drawArrow(
    p5,
    trimmerArrow1,
    trimmerArrow2,
    trait.window2.windowH + trait.window2.sill - trait.twoByW,
    pixels
  );

  if (trait.window2.windowW / pixels < 42) {
    if (trait.frenchDoor === "center") {
      let windowJack1 = p5.createVector(
        bottomBoard.x + trait.window2.windowW / 2,
        lintel
      );
      let windowJack2 = p5.createVector(
        0,
        trait.window2.windowH +
          (trait.h - frenchDoorH) / 2 -
          trait.header / 2 +
          trait.twoByW / 2
      );

      drawArrow(
        p5,
        windowJack1,
        windowJack2,
        trait.window2.windowH +
          trait.window2.sill -
          frenchDoorH -
          trait.frenchHeader -
          trait.twoByW,
        pixels
      );
    } else if (trait.frenchDoor === "left" || trait.frenchDoor === "right") {
      let windowJack1 = p5.createVector(bottomBoard.x, lintel);
      let windowJack2 = p5.createVector(
        0,
        trait.window2.windowH + trait.window2.sill + trait.twoByW / 2
      );
      drawArrow(
        p5,
        windowJack1,
        windowJack2,
        trait.window2.windowH + trait.window2.sill,
        pixels
      );
    }
  }
  return {
    x: xcenter + casementWidth,
    y: bottomBoard.y - trait.window2.windowH / 2 - trait.window2.sill,
  };
};
